<template>
  <b-card :header="caption">
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm"
             :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                    next-text="Next" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'c-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      fields: {
        type: Array
      },
      data: {
        type: Array,
        default: () => []
      },
      hover: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 10
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: true
      },
      small: {
        type: Boolean,
        default: true
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },

    data: () => {
      return {
        currentPage: 1,
        totalRows: 0
      }
    },

    methods: {
      getBadge(status) {
        return status === 'success' ? 'success'
          : status === 'failure' ? 'danger' : 'primary'

      },
      getRowCount(items) {
        return items.length
      }
    },

    computed: {
      items() {

        this.data.forEach(item => {
          item.start_time = moment.utc(item.start_time, ['YYYY-MM-DDTHH:mm:ssZ', 'MMM Do YYYY, h:mm:ss a']).format('MMM Do YYYY, h:mm:ss a');
          item.end_time = moment.utc(item.end_time, ['YYYY-MM-DDTHH:mm:ssZ', 'MMM Do YYYY, h:mm:ss a']).format('MMM Do YYYY, h:mm:ss a');
        });

        return this.data;
      }
    }
  }
</script>
